// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalWorkspaceEdit_base__5TKxw","label":"useModalWorkspaceEdit_label__2yrY1"};